import React, { useMemo, useRef, useState } from 'react';
import { CourseEntity } from 'Models/Entities';
import CompleteCreditChip from 'Views/Components/CourseAccordion/CompleteCreditChip';
import Chip from 'Views/Components/Chip/Chip';
import { capitalize, toLower } from 'lodash';
import ChipGroup from 'Views/Components/Chip/ChipGroup';

interface CompletedCourseAccordionProps {
	courses: CourseEntity[],
	totalUnits: number,
	getCourseComponents: (courseId: string) => string[];
}

const CompletedCourseAccordion = (props: CompletedCourseAccordionProps) => {
	const {
		courses,
		totalUnits,
		getCourseComponents,
	} = props;
	const [isOpen, setIsOpen] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	const completedUnits = useMemo(() => {
		return courses.reduce((acc, curr) => {
			return acc + curr.units;
		}, 0);
	}, [courses]);

	const getAccordionHeight = () => {
		if (!isOpen) {
			return 0;
		}

		const accordionHeaderHeight = 71;

		return contentRef.current ? contentRef.current.clientHeight + accordionHeaderHeight : '500px';
	};

	const sortedCourses = useMemo(
		() => courses.sort(CourseEntity.compareCodeAscending),
		[courses],
	);

	const renderCourse = (course: CourseEntity) => {
		const courseComponents = getCourseComponents(course.id);

		return (
			<div key={course.id} className="completed-course">
				<p>
					{course.code} <span className="course-name">{course.name}</span>
				</p>
				<ChipGroup>
					{courseComponents.map(component => (
						<Chip key={component} chipLabel={component} />
					))}
				</ChipGroup>
				<div className="unit-count">
					<CompleteCreditChip />
					<p>{course.units} {toLower(window.lexicon.unitsShort)}</p>
				</div>
			</div>
		);
	};

	return (
		<div className="completed-course-accordion" style={{ height: getAccordionHeight() }}>
			<button
				className="completed-course-accordion__header"
				onClick={() => {
					setIsOpen(!isOpen);
				}}
			>
				<h5>{capitalize(window.lexicon.units)} completed</h5>
				<div>
					<p>{completedUnits}/{totalUnits}</p>
					<span className="icon icon-right icon-expand-more" />
				</div>
			</button>
			<div ref={contentRef} className="completed-course-accordion__content">
				{
					sortedCourses.map(renderCourse)
				}
			</div>
		</div>
	);
};

export default CompletedCourseAccordion;
